module.exports = __webpack_public_path__ + "static/media/map-location.7f232715.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/map-location.svg
 ** module id = 457
 ** module chunks = 0
 **/